export default __webpack_public_path__ + "static/media/Marking-Paints.ede5b2ea.png";